import { v4 as uuidV4 } from 'uuid'

import { readable, writable, derived } from 'svelte/store'

import fetchClientList from './modules/fetchClientList/index.js'
import fetchMemberSheet from './modules/fetchMemberSheet/index.js'
import fetchReportHistory from './modules/fetchReportHistory/index.js'
import extractProjectHistory from './modules/extractProjectHistory/index.js'
import getUrlParams from './modules/getUrlParams/index.js'

/**
 * データを取ってくるPromiseを元にしたSvelteのReadable Storeを作るラッパー
 * @param {Promise} promise データを返すPromise
 * @returns svelte/store.readable
 */
const createReadableStore = promise =>
  readable(undefined, set => {
    promise().then(result => set(result))
  })

//  クライアント一覧
export const clientList$ = createReadableStore(fetchClientList)

// 社員 名簿
const memberSheet$ = createReadableStore(fetchMemberSheet)

// 作業日報用 作業員リスト
export const memberList$ = derived(memberSheet$, $memberSheet$ =>
  $memberSheet$
    ? $memberSheet$
        // 必要なデータだけ抜き出す
        .map(entry => ({
          sortOrder: parseInt(entry['社員番号']),
          name: entry['氏名'],
          isTarget: JSON.parse(entry['作業日報'].toLowerCase()),
        }))
        // 対象者だけに絞る
        .filter(member => member.isTarget)
        // ソートする
        .sort((a, b) => a.sortOrder - b.sortOrder)
        // 名前だけにする
        .map(member => member.name)
    : undefined
)

// 横田工業 日報用 作業員リスト
export const yokotaMemberList$ = derived(memberSheet$, $memberSheet$ =>
  $memberSheet$
    ? $memberSheet$
        // 必要なデータだけ抜き出す
        .map(entry => ({
          order: parseInt(entry['横田工業日報順序']),
          name: entry['氏名'],
        }))
        // 対象者だけに絞る
        .filter(member => member.order)
        // ソートする
        .sort((a, b) => a.order - b.order)
        // 名前だけにする
        .map(member => member.name)
    : undefined
)

// 作業日報 履歴
export const reportHistory$ = createReadableStore(fetchReportHistory)

// サジェスト用工事履歴
export const projectHistory$ = derived(reportHistory$, $reportHistory$ =>
  $reportHistory$ ? extractProjectHistory($reportHistory$) : undefined
)

// ローカルストレージに保存するStore
const createLocalStorageStore = (key, defaultValue) => {
  const store = writable(localStorage.getItem(key) || defaultValue)
  store.subscribe(value => {
    // 値を更新
    if (value) localStorage.setItem(key, value)
    // 無効な値ならエントリを削除(ローカルストレージに undefined 値は保存できない)
    else localStorage.removeItem(key)
  })
  return store
}

/**
 * デバイスID
 */
export const deviceId$ = createLocalStorageStore('deviceId', uuidV4())

/**
 * 利用者のロール
 *  URLパラメータから取得する。テストのためデータをセットできるよう writableにする。
 */
export const role$ = writable(getUrlParams().role)

/**
 * 報告者名
 */
export const reporterName$ = createLocalStorageStore('reporterName')
